<template>
  <v-container>
    <h1>Conversiones</h1>
    <v-row class="ma-0">
      <v-col cols="12" md="12" class="d-flex my-2 justify-end py-0 px-0">
        <div class="d-flex align-center" style="width: fit-content; background: #BFD7ED; box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15); border-radius: 10px; padding: 15px; border: 1px solid #C5CDD3;">
          <div class="pa-1 mr-3" style="background-color: #ECF6FF; border-radius: 5px;">
            <v-img src="../../assets/icons/trending-up.svg" style="width: 24px;"></v-img>
          </div>
          <div class="mr-1" style="font-family: 'montserrat-semibold';">{{ "Total currency gain: " }}</div>
          <span style="font-family: 'montserrat-bold'" :style="{ color: totalProfit < 0 ? '#0075B8' : '#0075B8'}"> 
            {{ " $" + formatMoney(totalProfit) + " " + (enterprise.enterprise.sAccountType == 'EFEXUSD' ? 'USD' : 'MXN') }}
          </span>
        </div>
      </v-col>
      <v-col class="pa-0 my-4">
        <v-text-field
          v-model="busqueda"
          placeholder="Buscar"
          clearable
          hide-details
          outlined
          style="width: 300px; font-family: 'montserrat-medium'; border-radius: 20px;"
          prepend-inner-icon="mdi-magnify"
        />
      </v-col>
      <v-col class="d-flex justify-end pa-0 my-4">
        <v-btn color="black" elevation="8" class="white--text ml-4" style="border-radius: 36px; border: 2px solid #000000; font-family: 'montserrat-semibold'; text-transform: none;" @click="dataXLSX()">
          <v-img class="mr-2" src="../../assets/icons/Vector.svg" style="width: 14px;"></v-img>
          {{ "Descargar" }}
        </v-btn>
      </v-col>
    </v-row>
    <v-skeleton-loader type="table" v-if="isLoading" />
    <v-data-table class="d-none d-sm-block" v-else :items-per-page="10" hide-default-header :items="filteredConversions" style="background-color: white !important">
      <template v-slot:header="{ props }">
        <thead style="background-color: #f9fafd;">
          <tr>
            <th class="header__title left">{{ "Id" }}</th>                                                                                                                                                                                  
            <th class="header__title center">{{ "Fecha de creación" }}</th>
            <th class="header__title center">{{ "Tipo de transaccion" }}</th>                                                                                                                                                                                                                          
            <th class="header__title center">{{ "Fecha de vencimiento" }}</th>
            <th class="header__title center">{{ "Tipo de cambio" }}</th>
            <th class="header__title center">{{ "Monto origen" }}</th>
            <th class="header__title center">{{ "Monto destino" }}</th>
            <th class="header__title center">{{ "Currency profit ($)" }}</th>
            <th class="header__title center">{{ "Currency profit (%)" }}</th>
            <th class="header__title center">{{ "Spread" }}</th>
            <th class="header__title center">{{ "Revenue" }}</th>
            <th class="header__title center">{{ "Fresher coins" }}</th>
            <th class="header__title center">{{ "Status" }}</th>
            <th class="header__title right">{{ "Acciones" }}</th>
          </tr>
        </thead>
      </template>
      <template v-slot:body="{ items }">
        <tbody style="background: #f9fafd;">
          <tr v-for="item in items" :key="item.id">
            <td class="table__item">{{ item.sTransactionId }}</td>
            <td class="table__item">{{ formatDate(item.created_at) }}</td>
            <td class="table__item">
              <v-chip v-if="item.sTransactionType == 'b80e8dc6-4138-449e-8903-968efb8437b3'" class="ma-2" color="red" outlined style="background-color: #FDF0F5 !important; border-width: 1.5px;">
                {{ "Forward" }}
              </v-chip>
              <v-chip v-else-if="item.sTransactionType == 'e7b157eb-8dcb-4655-8d0e-4eb4e7e9270a'" class="ma-2" color="#2397C7" outlined style="background-color: #F0F8FE !important; border-width: 1.5px;">
                {{ "Forex" }}
              </v-chip>
              <v-chip v-else-if="item.sTransactionType == '484a23d2-7dc1-4fd0-a1b0-3402d066c2cf'" class="ma-2" color="#FB0075" outlined style="background-color: #FDEBEB !important; border-width: 1.5px;">
                {{ "Window spot" }}
              </v-chip>
              <v-chip v-else class="ma-2" color="orange" outlined style="background-color: #FDF8EB !important; border-width: 1.5px;">
                {{ "Pay now" }}
              </v-chip>
            </td>
            <td class="table__item">{{ item.dForwardTransactionDate ? formatDate(item.dForwardTransactionDate) : "-" }}</td>
            <td class="table__item">{{  "$ " + formatMoney(item.dExchangeRate < 1 ? 1 / item.dExchangeRate : item.dExchangeRate) + " MXN" }}</td>
            <td class="table__item">{{ "$ " + formatMoney(item.dAmount) + " " + (item.sCurrency ? item.sCurrency : "USD") }}</td>
            <td class="table__item">{{ "$ " + formatMoney(item.dDesAmount) + " " + (item.sDestCurrency ? item.sDestCurrency : "MXN") }}</td>
            <td class="table__item" :style="item.dCurrencyGain == 0 ? 'color: black;' : (item.dCurrencyGain > 0 ? 'color: #4CAF50;' : 'color: #E74C3C;')">{{ item.dCurrencyGain ? ('$ ' + formatMoney(item.dCurrencyGain) + ' ' + (enterprise.enterprise.sAccountType == 'EFEXUSD' ? 'USD' : 'MXN')) : "-" }}</td>
            <td class="table__item" :style="item.dProfitPercentage == 0 ? 'color: black;' : (item.dProfitPercentage > 0 ? 'color: #4CAF50;' : 'color: #E74C3C;')">{{ item.dProfitPercentage ? formatMoney(item.dProfitPercentage) + "%" : "-" }}</td>
            <td class="table__item">{{ parseFloat(item.spread).toFixed(6).replace(/\.?0+$/, '') + "%" }}</td>
            <td class="table__item">{{ item.re ? "$ " + formatMoney(item.re) + " USD" : "-" }}</td>
            <td class="table__item">{{ item.fresherCoins ? formatMoney(item.fresherCoins) : "-" }}</td>
            <td class="table__item">{{ item.sStatusId == '5a792637-1103-4a89-8f67-86c49b93e227' ? "Concretada" : (item.sStatusId == '679d409d-8fa9-404c-8fc7-9352e198c072' ? "Pendiente" : ((item.sStatusId == '4291b132-d28b-4b52-844a-77e4216857aa' ? "Finalizada" : item.sStatusId == '94bbc2b7-6e31-4523-b438-58c1987a907b' ? "Abierta" : "N/A")))}}</td>
            <td class="table__item">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="openDetail(item)" v-bind="attrs" v-on="on" icon color="black">
                    <v-icon>mdi-eye-outline</v-icon>
                  </v-btn>
                </template>
                <span>Detalle</span>
              </v-tooltip>
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>

    <v-dialog v-model="showDetailDialog" max-width="1400px" scrollable>
      <v-card>
        <v-card-text class="pa-0">
          <ConversionDetailContent
            v-if="selectedTransactionId"
            :s-transaction-id="selectedTransactionId"
            @close="showDetailDialog = false"
            @go-to-payment="goToPayment"
            @go-to-invoice="goToInvoice"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
  import * as XLSX from "xlsx";
  import { saveAs } from "file-saver";
  import moment from "moment";
  import ConversionDetailContent from "@/views/History/ConversionDetailContent.vue";

  export default {
    name: "Conversiones",
    components: {
      ConversionDetailContent,
    },
    props: {
      activeTab: String,
      permissionList: Array,
      enterprise: Object
    },
    data() {
      return {
        conversionsRaw: [],
        busqueda: "",
        totalProfit: 0,
        isLoading: true,
        dialogRequestPayment: false,
        forward: null,
        showDetailDialog: false,
        selectedTransactionId: null,
      };
    },
    watch: {
      activeTab(val) {
        if (val === 'conversiones') {
          this.getConversions();
        }
      }
    },
    computed: {
      filteredConversions() {
        if (!this.busqueda) return this.conversionsRaw;

        const filtro = this.busqueda.toLowerCase();

        return this.conversionsRaw.filter((item) => {
          const tipo = this.getTransactionTypeName(item.sTransactionType).toLowerCase();
          const estatus = this.getStatusName(item.sStatusId).toLowerCase();
          const fechaCreacion = this.formatDate(item.created_at).toLowerCase();
          const fechaForward = item.dForwardTransactionDate ? this.formatDate(item.dForwardTransactionDate).toLowerCase() : "-";
          const tipoCambio = `$ ${this.formatMoney(item.dExchangeRate < 1 ? 1 / item.dExchangeRate : item.dExchangeRate)} MXN`.toLowerCase();
          const montoOrigen = `$ ${this.formatMoney(item.dAmount)} ${item.sCurrency || 'USD'}`.toLowerCase();
          const montoDestino = `$ ${this.formatMoney(item.dDesAmount)} ${item.sDestCurrency || 'MXN'}`.toLowerCase();

          return (
            String(item.iTrackingId).toLowerCase().includes(filtro) ||
            fechaCreacion.includes(filtro) ||
            tipo.includes(filtro) ||
            fechaForward.includes(filtro) ||
            tipoCambio.includes(filtro) ||
            montoOrigen.includes(filtro) ||
            montoDestino.includes(filtro) ||
            estatus.includes(filtro)
          );
        });
      }
    },
    mounted() {
      if (this.activeTab === 'conversiones') {
        this.getConversions();
      }
    },
    methods: {
      getConversions() {
        this.isLoading = true;
        this.totalProfit = 0;
        this.conversionsRaw = [];
        const payload = {
          sEnterpriseId: this.$route.params.sEnterpriseId,
        };

        DB.post(`${URI}/api/v1/en/administrator/conversions`, payload, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        })
        .then((response) => {
          this.conversionsRaw = response.data.transactions;
          this.conversionsRaw.forEach((conversion) => {
            this.totalProfit += parseFloat(conversion.dCurrencyGain);
          });
          this.isLoading = false;
        }).catch((error) => {
          if (error.response.data.code) {
            this.$router.push("/welcome").catch(() => {});
          }
          this.mixError(error.response.data.message, error.response.status);
        });
      },
      getTransactionTypeName(id) {
        switch (id) {
          case 'b80e8dc6-4138-449e-8903-968efb8437b3': return 'Forward';
          case 'e7b157eb-8dcb-4655-8d0e-4eb4e7e9270a': return 'Forex';
          case '484a23d2-7dc1-4fd0-a1b0-3402d066c2cf': return 'Window spot';
          default: return 'Pay now';
        }
      },
      getStatusName(id) {
        switch (id) {
          case '5a792637-1103-4a89-8f67-86c49b93e227': return 'Concretada';
          case '679d409d-8fa9-404c-8fc7-9352e198c072': return 'Pendiente';
          case '4291b132-d28b-4b52-844a-77e4216857aa': return 'Finalizada';
          case '94bbc2b7-6e31-4523-b438-58c1987a907b': return 'Abierta';
          default: return 'N/A';
        }
      },
      formatMoney(value) {
        let multiplied = value * 100;
        let rounded = Math.round(multiplied);
        let formattedNumber = rounded / 100;
        // Si el valor es -0, lo convertimos a 0
        if (Object.is(formattedNumber, -0)) {
          formattedNumber = 0;
        }
        return new Intl.NumberFormat("en-US", {
          style: "decimal",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(formattedNumber);
      },
      formatDate: function (date) {
        if (this.selectLanguage === "sp") {
          moment.locale("es");
        } else {
          moment.locale("en");
        }
        let newDate = moment(date);
        let formattedDate = newDate.format("MMMM DD, YYYY HH:mm a");
        return formattedDate;
      },
      dataXLSX() {
        try {
          const data = this.conversionsRaw.map((item) => ({
            "ID de seguimiento": item.sTransactionId || "-",
            "Fecha de creación": item.created_at ? this.formatDate(item.created_at) : "-",
            "Tipo de operación": this.getTransactionTypeName(item.sTransactionType),
            "Fecha forward": item.dForwardTransactionDate ? this.formatDate(item.dForwardTransactionDate) : "-",
            "Tipo de cambio": `${this.formatMoney(item.dExchangeRate < 1 ? 1 / item.dExchangeRate : item.dExchangeRate)}`,
            "Monto origen": `${this.formatMoney(item.dAmount)}`,
            "Monto destino": `${this.formatMoney(item.dDesAmount)}`,
            "Currency Origen": item.sCurrency || 'USD',
            "Currency Destino": item.sDestCurrency || 'MXN',
            "Estatus": this.getStatusName(item.sStatusId),
          }));

          const worksheet = XLSX.utils.json_to_sheet(data);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Conversiones");

          const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
          const blob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });

          saveAs(blob, "Conversiones.xlsx");

          this.success = true;
          this.msgSuccess = "Descargando conversiones";
        } catch (error) {
          console.error("Error al generar XLSX de conversiones:", error);
          this.error = true;
          this.codeError = "XLSX_CONVERSIONS_FAILED";
        }
      },
      openDetail(item) {
        this.selectedTransactionId = item.sTransactionId;
        this.showDetailDialog = true;
      },
      goToPayment(item) {
        this.showDetailDialog = false;
        this.$router.push({
          name: "PaymentDetail",
          params: { sPaymentId: item.sPaymentId }
        }).catch(() => {});
      },
      goToInvoice(item) {
        this.showDetailDialog = false;
        this.$router.push({
          name: "InvoiceDetail",
          params: { sInvoiceId: item.invoice.sInvoiceId }
        }).catch(() => {});
      },
    }
  };
</script>
<style scoped>
</style>